const initialState = {
  inputProps: {
    onUploadStart: () => {},
    onUploadComplete: () => {},
    accept: '*',
  },
  isUploading: false,
  file: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FILE_INPUT/REPLACE_PROPS':
      return {
        ...state,
        inputProps: action.inputProps,
      };
    case 'FILE_INPUT/SET_UPLOADING':
      return {
        ...state,
        isUploading: action.isUploading,
      };
    case 'FILE_INPUT/SET_FILE':
      return {
        ...state,
        file: action.file,
      };
    case 'FILE_INPUT/UPDATE_FILE':
      return {
        ...state,
        file: {
          ...state.file,
          ...action.update,
        },
      };
    case 'FILE_INPUT/SET_ERROR':
      return {
        ...state,
        error: action.error,
      };
    case 'FILE_INPUT/RESET_FILE':
      return {
        ...state,
        file: null,
        error: null,
        isUploading: false,
      };
    case 'FILE_INPUT/RESET_INPUT':
      return initialState;
    default:
      return state;
  }
};
